import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/libs/auth/auth.service';
import { WebauthnService } from 'src/libs/auth/webauthn.service';
import { LoginHeaderService } from 'src/libs/state/login-header.service';
import { StateService } from 'src/libs/state/state.service';

@Component({
  selector: 'fini-login-mfa',
  templateUrl: './login-mfa.component.html',
  styleUrls: ['./login-mfa.component.scss'],
  standalone: false,
})
export class LoginMfaComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    private toast: HotToastService,
    private state: StateService,
    private webAuthnService: WebauthnService,
    private header: LoginHeaderService,
  ) {
    // Push header data up the tree
    this.header.set({
      title: 'Security',
      subtitle: 'We need your second factor for security',
    });
  }

  username = '';
  password = '';
  mfaToken = '';

  loading = signal(false);

  ngOnInit(): void {
    const state = this.router.lastSuccessfulNavigation?.extras.state;
    if (!state) {
      return;
    }
    this.username = state.username;
    this.password = state.password;
  }

  login(passkey = false) {
    const { username, password } = this;

    this.loading.set(true);
    this.auth
      .login({ username, password, mfa_token: this.mfaToken, passkey })
      .subscribe(() => {
        this.loading.set(false);
      });
  }

  async loginPasskey() {
    this.loading.set(true);

    const payload = await this.webAuthnService.getMFACodePayload(this.username);
    if (!payload) {
      this.toast.error('Passkey not found');
      this.loading.set(false);
      return;
    }

    this.mfaToken = payload;
    this.login(true);
  }
}
